import mitt from 'mitt';

export default mitt;
